import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import appTheme from '../../themes/Theme';

export const StyledHeader = styled.h2`
  padding-top: 16px;
  text-align: center;
  margin-top: 0;
`;

export const StyledListItem = styled.li`
  margin-top: 24px;
`;

export const StyledButton = styled(Button)`
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 24px !important;
  &.MuiButton-contained.Mui-disabled {
    color: #fff;
    background-color: ${appTheme.buttonDisabledBgColor};
  }
`;
